import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

// PWA update flow:
//   - Register sw.js
//   - Poll for updates every 60s + whenever the tab becomes visible
//   - When a new SW finishes installing and there is an existing controller,
//     send SKIP_WAITING. The new SW activates, fires controllerchange, and
//     we silently reload to pick up the new app code.

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");

      const check = () => reg.update().catch(() => {});
      setInterval(check, 60_000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") check();
      });

      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            installing.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });

      let reloading = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloading) return;
        reloading = true;
        window.location.reload();
      });
    } catch (e) {
      console.warn("SW registration failed", e);
    }
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
